import React from 'react';
import { t } from '../../../i18n';
import { arrowRightPointerIcon } from '../../assets/index';
import Button from '../../../components/button/index';
import './styles.scss';

const ShowAllFewerCoursesButton = ({ showAllCourses, onClick }) => {
  return (
    <Button
      className="show-all-fewer-courses-button"
      text={
        <span>
          {showAllCourses
            ? t('DIGITAL_COURSES.COURSES_LIST.VIEW_FEWER_COURSES')
            : t('DIGITAL_COURSES.COURSES_LIST.VIEW_ALL_COURSES')}
          <img src={arrowRightPointerIcon} alt="arrow-right" />
        </span>
      }
      onClick={onClick}
    />
  );
};

export default ShowAllFewerCoursesButton;
